import React from "react";
import formatNumber from "../../../helpers/NumberFormat";
import "./transfer.scss";

const FormStep2 = ({ isMobile, setTransactionStep, handleChange, data, main }) => {

    const wrapInputWithIcon = (icon, inputElement) => (
        <div className="input-group">
            <div className="input-group-text bg-white border-end-0">
                <i className={`fa-solid ${icon} text-muted`} />
            </div>
            {inputElement}
        </div>
    );

    return (
        <form className="w-100 mb-4">

            <h5 className="text-muted mb-3">
                <i className="fa-solid fa-user me-2" />
                Debit account
            </h5>

            <div className="bg-custom-dark px-3 py-4 mb-3 rounded shadow-sm">
                <h5 className="text-muted mb-4">Account report</h5>

                <div className="row g-5">
                    <div className="col-md-6">
                        <div className="d-flex flex-column gap-2">
                            <div className="d-flex justify-content-between">
                                <span>Registered To:</span>
                                <strong>{main?.user?.first_name} {main?.user?.last_name}</strong>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span>Account Number:</span>
                                <strong>{main?.user?.detail?.account_number?.replace(/^.*?-/, '')}</strong>
                            </div>
                            {/* <div className="d-flex justify-content-between">
                                <span>Branch:</span>
                               <strong>{main?.user?.first_name} {main?.user?.last_name}</strong>
                            </div> */}
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex flex-column gap-2">
                            <div className="d-flex justify-content-between">
                                <span>Available balance:</span>
                                <strong>{formatNumber(main?.user?.balance)} €</strong>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span>Account balance:</span>
                                <strong>{formatNumber(main?.user?.balance)} €</strong>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span>Credit limit:</span>
                                <strong>{formatNumber(0)} €</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-3 mb-2">
                <h5 className="text-muted mb-3">
                    <strong>Credit amount</strong>
                </h5>

                <div className="row g-5">
                    <div className="col-md-6">
                        <label className="form-label mb-2">Amount*</label>
                        <input value={data.amount} type="number" name="amount" className="form-control" placeholder="0,00" onChange={handleChange} />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label mb-2">Currency*</label>
                        <select name="valuta" className="form-control border-start-0" defaultValue="">
                            <option value={'EURO - EURPOEAN UNIION'} disabled>Select a valute</option>
                            {["EURO - EUROPEAN UNION"].map(valute => (
                                <option key={valute} value={valute}>{valute}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="p-3 mb-3">
                <h5 className="text-muted mb-4">
                    <strong>Beneficiary data</strong>
                </h5>

                <div className="row g-5 mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Name surname or company name*</label>
                        <input
                            type="text"
                            name="beneficary_name"
                            value={data.beneficary_name}
                            className="form-control"
                            placeholder="Please enter name surname or company name"
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Transfer destination*</label>
                        <div className="input-group">
                            <span className="input-group-text bg-white border-start-0 border-top-0 border-end-0">
                                <i className="fa-solid fa-globe text-muted" />
                            </span>
                            <select
                                name="beneficary_country"
                                className="form-control border-start-0"
                                defaultValue=""
                                onChange={handleChange}
                            >
                                <option value="" disabled>Select a country</option>
                                {[
                                    "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark",
                                    "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland", "Italy",
                                    "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands", "Poland", "Portugal",
                                    "Romania", "Slovakia", "Slovenia", "Spain", "Sweden"
                                ].map(country => (
                                    <option key={country} value={country}>{country}</option>
                                ))}
                            </select>
                            <span className="input-group-text bg-white border-start-0 border-top-0 border-end-0">
                                <i className="fa-solid fa-caret-down text-muted" />
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row g-5 mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Beneficiary’s IBAN*</label>
                        <input
                            type="text"
                            name="iban"
                            value={data.iban}
                            className="form-control"
                            placeholder="Please enter: IBAN"
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Bank Name*</label>
                        <input
                            type="text"
                            name="bank_name"
                            value={data.bank_name}
                            className="form-control"
                            placeholder="Please enter: Bank Name"
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="row g-5">
                    <div className="col-md-6">
                        <label className="form-label">BIC/SWIFT*</label>
                        <input
                            type="text"
                            name="swift_code"
                            value={data.swift_code}
                            className="form-control"
                            placeholder="Please enter: BIC/SWIFT"
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>


            <div className="p-3 mb-2">
                <h5 className="text-muted mb-3">
                    <strong>Payment Reason</strong>
                </h5>

                <div className="row">
                    <div className="col-md-12">
                        <div className="m-auto justify-content-between">
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    Payment description* (min 4, max 140 characters — special characters like #$%^&(){ }@ etc. are not allowed)
                                </div>
                                <textarea value={data.description} name="description" className="form-control border-start-0" placeholder="Please enter: Description" onChange={handleChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12">
                    <p className="text-muted">
                        Click on "<strong>NEXT</strong>" to choose the <strong>crediting time and the type of transfer</strong> (Standard / Urgent / Instant).
                    </p>
                </div>

            </div>
            <div className="row mt-2">
                <div className="col-md-12">
                    <small className="text-muted">
                        The fields marked with an asterisk (*) are mandatory.
                    </small>
                </div>
                <div className="col-md-12">
                    <small className="text-muted">
                        The bank is relieved of any responsibility for incorrect entry of mandatory data.
                    </small>
                </div>
            </div>

            {/* <div className="bg-light p-3 rounded mb-4 border">
                <div className="form-group mb-3">
                    <label className="lightgray2">Beneficiary Address</label>
                    {wrapInputWithIcon("fa-location-dot", (
                        <input value={data.beneficary_address} type="text" name="beneficary_address" className="form-control border-start-0" placeholder="Please enter: Beneficiary Address" onChange={handleChange} />
                    ))}
                </div>
            </div> */}
        </form>
    )
};

export default FormStep2;